import { render } from "./TableUsers.vue?vue&type=template&id=b987299c&scoped=true"
import script from "./TableUsers.vue?vue&type=script&lang=js"
export * from "./TableUsers.vue?vue&type=script&lang=js"

import "./TableUsers.vue?vue&type=style&index=0&id=b987299c&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b987299c"]])

export default __exports__